import axios from 'axios';

import HTTP from '@api';

import { generateXHRError } from '@helpers';

let cancelRequest;
const { CancelToken } = axios;

export default {
  namespaced: true,
  state: {
    notifications: [],
    notificationsHistory: [],
  },
  mutations: {
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setNotificationsHistory(state, payload) {
      state.notificationsHistory = payload;
    },
  },
  actions: {
    async getNotifications(
      { commit, rootState: { locations } },
      { suffix = locations.suffix } = {},
    ) {
      if (cancelRequest) {
        cancelRequest('Canceled previous request to /notifications/new');
      }
      try {
        const { data } = await HTTP.get(`${suffix}/notifications/new`, {
          cancelToken: new CancelToken((c) => {
            cancelRequest = c;
          }),
        });
        commit('setNotifications', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async getNotificationsHistory(
      { commit, rootState: { locations } },
      { suffix = locations.suffix, pageNum = 1, pageSize = 10 },
    ) {
      try {
        const { data } = await HTTP.get(`${suffix}/notifications`, {
          params: { pageNum, pageSize },
        });
        commit('setNotificationsHistory', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async deleteNotifications(
      { commit, rootState: { locations } }, // eslint-disable-line
      { suffix = locations.suffix, ids },
    ) {
      try {
        await HTTP.delete(`${suffix}/notifications`, {
          data: { ids },
        });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
